import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Button } from "react-bootstrap";
import { BUSQUEDA, ERASER } from "../../../components/iconsSVG/IconsSVG";

const BotonesBusquedaDescargaTomos = ({ onSearch, onReset }) => {
  const handleSearch = () => {
    onSearch();
  };

  const handleReset = () => {
    onReset();
  };

 
  return (
    <div>
       <Row  className="p-0 m-0 gap-3">
       <Col xs="auto" className="d-flex justify-content-center p-0 m-0 mb-1 mb-lg-0 ">
          <Button className="btn-azul w-100" onClick={handleSearch}>
            <BUSQUEDA />&nbsp;&nbsp;BUSCAR
          </Button>
        </Col>
        <Col xs="auto" className="d-flex justify-content-center p-0 m-0 mb-1 mb-lg-0 ">
          <Button className="btn-blue-border w-100" onClick={handleReset}>
            <ERASER />&nbsp;&nbsp;LIMPIAR
          </Button>
        </Col>
      </Row>
    </div>
  );
};

BotonesBusquedaDescargaTomos.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default BotonesBusquedaDescargaTomos;
